import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { Typography, 
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';

       // ref: https://dzone.com/articles/how-to-use-bootstrap-carousel-in-reactjs
import Carousel from 'react-bootstrap/Carousel'     // sudo yarn add  react-bootstrap bootstrap@5.0.2



const intro_useStyles = makeStyles(theme => ({
    intro_root: {
        position: 'absolute',
        top: '35vh',
        //left: '0',
        display: 'flex',
        flexDirection: 'column',
        //maxHeight: '90vh',
        //minWidth: '350px',
        width: `calc(100% - 20px)`,
        maxWidth: '780px',
        height: '30vh',
        margin: '0vh 10px',
        zIndex: '200',
        backgroundColor:'#444444',	//4488ff
    },
    block_root: {
        display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor:'#999999',	//4488ff
    },
    two_root: {
        display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor:'#44cc44',	//4488ff
    },
    three_root: {
        display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor:'#4444cc',	//4488ff
    },
    hidden: {
        display: "none",
    },
    spinner_text: {
        display: 'flex'
    },
    block_carousel_container: {
        display: 'block',
        height: '100%',
    },
    block_carousel_item: {
        height: '100%',
        //height: '500px',
    },
    b1: {
        display: 'none',
        position: "absolute",
        background: 'purple',
        top: '30%',
        left: '15%',
        width: '40px',
        height: '40px',
        color: '#fff',
    },
    b2: {
        display: 'none',
        position: "absolute",
        background: 'blue',
        top: '40%',
        left: '65%',
        width: '40px',
        height: '40px',
        color: '#fff',
    },
    b3: {
        display: 'none',
        position: "absolute",
        background: 'red',
        top: '80%',
        left: '75%',
        width: '40px',
        height: '40px',
        color: '#fff',
    },
    t1: {
        display: 'none',
        position: "absolute",
        background: 'purple',
        width: '40px',
        height: '40px',
        color: '#fff',
    },
}));



var delay_timer;
const Block = (props) => {
    var block_idx = 0;
    const classes = intro_useStyles();
    const [ Motions, setMotions ] = useState(null);

    useEffect(() => {
        return function cleanup() {
            if(delay_timer !== null) {
                clearTimeout(delay_timer);
            }
        }
    }, [1]); 

    useEffect(() => {
        setMotions(props.Motions);

        if (props.Active === props.ID) {
            console.log("block.102:   INIT --------- motions=",props.Motions, " Active=",props.Active, " ID=",props.ID);
            clear_nodes();  // start over

            block_idx = 0;
            var motion = props.Motions[block_idx];
            var delay = motion.delay;

            delay_timer = setTimeout(processBlockTimer.bind(this), delay);
        }
    }, [props.Active]); 

    function clear_nodes() {
        var nodes = ["b1", "b2", "b3", "n1", "n2", "n3"]
        for (var i in nodes) {
            var n = nodes[i];
            var node_id = props.ID+n;
            console.log("block.134:         REMOVE --------- node_Id=",node_id, " n=",n);
            var ele = document.getElementById(node_id);
            if(ele !== null) {
                ele.style.display = "none";
            }
        }
    }

    function processBlockTimer() {

        if (block_idx < props.Motions.length) {
            var motion = props.Motions[block_idx];
            var motion1 = props.Motions[block_idx+1];
            var delay = (motion1 === undefined) ? 0 : motion1.delay;
            var node = motion.node;
            var action = motion.action;
            var text = motion.text;
            var x = motion.x;
            var y = motion.y;
            var node_id = props.ID + node;

            var ele = document.getElementById(node_id);
            if(ele === null) {
                console.log("block.142:    !!!!!!!! BAD NODE_ID= ", node_id);
                return;
            }
            switch (action) {
                case "show":
                    console.log("block.120:      +++++ SHOW ", node_id, " text=",text, " x=",x, " y=",y);
                    ele.style.display = "block";
                    ele.innerText = text;
                    if (x !== undefined) ele.style.left = x;
                    if (y !== undefined) ele.style.top = y;
                    break;
                case "hide":
                    console.log("block.123:      +++++ HIDE ", node_id);
                    ele.style.display = "none";
                    break;
                default:
                    console.log("block.131:      +++++ UNKNOWN Action=", action);
                    break;
            }

            //console.log("Intro.145:                 = = = = = = = INTRO TIMER = = = = = = =  ", block_idx);
            //setShowBlock(ShowBlock + 1);
            if ((props.Active === props.ID) && (delay > 0)) {
                delay_timer = setTimeout(processBlockTimer.bind(this), delay);
            } else {
                delay_timer = null;
            }
            block_idx = block_idx + 1;
        }
    }


    return (
        <React.Fragment>
            <Container id="block_root" 
                style= {{'background': props.Color, "height": "30vh"}}
                className={classes.block_root} >
                {props.Text}

                <div id={props.ID+"b1"} className={classes.b1} > </div>
                <div id={props.ID+"b2"} className={classes.b2} > </div>
                <div id={props.ID+"b3"} className={classes.b3} > </div>
                <div id={props.ID+"n1"} className={classes.t1} > </div>
                <div id={props.ID+"n2"} className={classes.t1} > </div>
                <div id={props.ID+"n3"} className={classes.t1} > </div>

            </Container>
        </React.Fragment>
    )
}



const Intro = (props) => {
    const classes = intro_useStyles();
    const [ Show, setShow ] = useState(props.Show); 
    const [ ShowBlock, setShowBlock ] = useState(0); 
    const [ Motions, setMotions ] = useState([]);
    const [ BlockIndex, setBlockIndex ] = useState(0);

    useEffect(() => {
		console.log("Intro.INIT.60: running useEffect() ", props);
		document.addEventListener('keydown', function(event) {
			if(event.code == "ArrowLeft") {
				//console.log('Left was pressed');
			} else if(event.code == "ArrowRight") {
				//console.log('Right was pressed');
			}
		});

        var motions = [];
        motions[0]= [{delay: 1000, node: "b1", text: "INTERACTIVE", action: "show"},
                       {delay: 1500, node: "n1", x: "20%", y: "50%", text: "1", action: "show"},
                       {delay: 1500, node: "n2", x: "50%", y: "50%", text: "2", action: "show"},
                       {delay: 1500, node: "n3", x: "80%", y: "50%", text: "3", action: "show"}];

        motions[1] = [{delay: 1000, node: "b2", action: "show"},
                       {delay: 2000, node: "b2", action: "hide"},
                       {delay: 1000, node: "b2", action: "show"},
                       {delay: 2000, node: "b2", action: "hide"}];

        motions[2] = [{delay: 1000, node: "b3", action: "show"},
                       {delay: 1000, node: "b3", action: "hide"},
                       {delay: 2000, node: "b3", action: "show"},
                       {delay: 1000, node: "b3", action: "hide"}];

        setMotions(motions);
        /*
        var blocks = [  <Block ID={0} Active={BlockIndex} Text={"First one"} Color={"#999"} Motions={motion1}/>,
                        <Block ID={1} Active={BlockIndex} Text={"Second one"} Color={"#999"} Motions={motion2} />,
                        <Block ID={2} Active={BlockIndex} Text={"Last one"} Color={"#999"} Motions={motion3} />]
        setBlocks(blocks);
        */

        return function cleanup() {
            if(delay_timer !== null) {
                clearTimeout(delay_timer);
            }
        }
    }, [1]); 

    useEffect(() => {
        console.log("Intro.155:                 + + + + + + + USEEFFECT SHOWBLOCK + + + + + + +   Active=",BlockIndex);
        setShow(props.Show);
    }, [props.Show, ShowBlock, BlockIndex]); 



    const handleCarouselSelect = (selectedIndex, e) => {
        //console.log("leader_select.1821:   ~~~~~~~~~~~ Block new index=",selectedIndex);
        setBlockIndex(selectedIndex);
    };

                    //{/* style= {{'height': "calc("+props.Height+"px - 30px)"}} */ }
                            //{/* style= {{'height': "calc("+props.Height+"px - 30px)"}} */}

    return (
        <React.Fragment>
        {Show && <Container id="intro_root" className={classes.intro_root} >

            {/* src: https://react-bootstrap.github.io/components/carousel/ */}
            <Carousel id="block_carousel_container" 
                    controls={false} 
                    interval={10000} 
                    indicators={true}
                    activeIndex={BlockIndex} 
                    onSelect={handleCarouselSelect}
                    className={classes.block_carousel_container} >

                {Motions && Motions.map((motion, index1) => {
                    return(
                        <Carousel.Item id={"citem_"+index1} 
                            key={"lead_citem_"+index1}  
                            className={classes.block_carousel_item}>

                            {<Block ID={index1} Active={BlockIndex} Motions={motion} />}

                        </Carousel.Item>
                    )
                }) }

            </Carousel>

	    </Container> }
	</React.Fragment>
    )
}

export default Intro;